import {
  CurrencyPipe,
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
} from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CartLine } from 'src/app/classes/utility';
import { ShopifyService } from 'src/app/service/shopify.service';
import { QtyComponent } from 'src/app/snippet/qty/qty.component';

@Component({
  selector: 'app-lineitem',
  standalone: true,
  imports: [QtyComponent, CurrencyPipe, NgClass, NgIf, NgFor, NgOptimizedImage],
  templateUrl: './lineitem.component.html',
  styleUrl: './lineitem.component.scss',
})
export class LineitemComponent implements OnChanges {
  @Input() lineItem!: CartLine;
  _attributes: any = [];
  _preorder: any;
  _gift: any;
  _colours = [
    { label: 'Hot Pink', hex: '#d400d0' },
    { label: 'Baby Pink', hex: '#ec8ad5' },
    { label: 'Purple', hex: '#860cb9' },
    { label: 'Lilac', hex: '#cdaaec' },
    { label: 'Teal', hex: '#2b889c' },
    { label: 'Blue', hex: '#0e76f9' },
    { label: 'Green', hex: '#10b20f' },
    { label: 'Yellow', hex: '#f9ca00' },
    { label: 'Orange', hex: '#ea9500' },
    { label: 'Red', hex: '#dc0c0c' },
    { label: 'White', hex: '#ffffff' },
    { label: 'Black', hex: '#000000' },
  ];

  constructor(private shopifyService: ShopifyService) {}

  remove() {
    this.shopifyService
      .removeFromCart([this.lineItem.id])
      .subscribe((data) => {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._attributes = [];
    this._preorder = this.lineItem.attributes.find((x) => x.key == 'Preorder');
    this._gift = this.lineItem.attributes.find((x) => x.key == '_freegift');

    if (this.lineItem.attributes.find((x: any) => x.key === 'Personalised')) {
      for (let entry of this.lineItem.attributes.filter(
        (x: any) =>
          x.key !== 'Preorder' &&
          x.key !== 'Personalised' &&
          x.key !== '_Personalisation'
      )) {
        this._attributes.push({
          prefix: entry.key,
          key: entry.value.split('/')[0],
          value: entry.value.split('/')[1],
          hex: this._colours.find((x) => x.label == entry.value.split('/')[1])!
            .hex,
        });
      }
    }
  }
}
